<template>
    <div id="page-user-list">
      <div class="vx-card p-6">
      <div class="flex flex-wrap items-center">
        <div class="flex-grow mb-3">
          <vs-button
            color="primary"
            type="border"
            icon-pack="feather"
            icon="icon-plus"
            @click="addAccount"
            >
            {{$t('adminUserICon.title')}}
          </vs-button>
        </div>
        <div class ="flex-grow">
          </div>
          <vs-input
          class="sm:mr-4 mr-0 sm:w-auto w-full sm:order-normal order-3 sm:mt-0 mt-4"
          :placeholder ="$t('adminUserICon.search')"
          v-model="account"
          icon-pack="feather"
          icon="icon-search"
          @keypress.enter="searchAccount"
           />
      </div>

      <ag-grid-vue
        class="ag-theme-material w-100 my-4 ag-grid-table"
        style="height:55vh"
        ref="agGridTable"
        :components ="components"
        :gridOptions="gridOptions"
        :columnDefs="columnDefs"
        :defaultColDef = "defaultColDef"
        :rowData = "rowData"
        :animateRows = "true"
        :pagination = "true"
        :paginationPageSize ="20"
        :onGridReady ="onGridReady"
        :suppressPaginationPanel = "true"
        :per-page="0"
      >
      </ag-grid-vue>
      <vs-pagination
      :total ="totalPages"
      :max="maxPageNumbers"
      v-model="currentPage"
      :per-page="perPage"
      @change="onChangePage"
      ></vs-pagination>
    </div>
  </div>
</template>
<script>
import { AgGridVue } from "ag-grid-vue";
import "@/assets/scss/vuexy/extraComponents/agGridStyleOverride.scss";
import CellRendererActions from './cell-renderer/CellRendererActions.vue';
import CellRendererUsed from './cell-renderer/CellRendererUsed.vue';
import CellRendererValid from './cell-renderer/CellRendererValid.vue';
import moment from 'moment';
export default {
  components:{
    AgGridVue,
    CellRendererActions,
    CellRendererUsed,
    CellRendererValid,
    moment
  },
  data(){
    return{
      account:null,
      rowData: [],
      maxPageNumbers: 6,
      totalPages: 0,
      perPage: 10,
      gridApi: null,
      gridOptions: {},
      defaultColDef: {},
      gripApi: null,
      pageNumbers: 0,
      pageSize: null,
      currentPage: 1,
      components: {
        AgGridVue,
        CellRendererActions,
        CellRendererUsed,
        CellRendererValid
      },
      columnDefs: [
        {
          headerName: this.$t('adminUserICon.account'),
          field: "account",
          width: 100
        },
        {
          headerName: this.$t('adminUserICon.pass'),
          field: "password",
          width: 100
        },
        {
          headerName: this.$t('adminUserICon.creatorCode'),
          field: 'pidUsed',
          width:100
        },
        {
          headerName:this.$t('adminUserICon.creator'),
          field:'lastUsedBy',
          width:100
        },
        {
          headerName: this.$t('adminUserICon.dateCreated'),
          field: 'created',
          width:100
        },
        {
          headerName:this.$t('adminUserICon.accountStatus'),
          field: "used",
          width:120,
          cellRendererFramework:'CellRendererUsed'
        },
        {
          headerName: this.$t('adminUserICon.effect'),
          field: 'valid',
          width:100,
          cellRendererFramework: 'CellRendererValid'
        },
        {
          headerName: this.$t('adminUserICon.action'),
          field: "transaction",
          width: 80,
          cellRendererFramework:'CellRendererActions'
        }
      ],

    }
  },
  watch: {
    "$store.state.isUpdateUser"(val) {
      if (val) {
        this.initScreen();
        this.$store.commit("UPDATE_USER_SUCCESS", false);
      }
    }
  },
  methods:{
    onGridReady() {
      if (this.$store.state.windowWidth <= 1024) {
        this.maxPageNumbers = 5;
      } else {
        this.maxPageNumbers = 7;
      }
      if (this.$store.state.windowWidth > 1024) {
        this.gridApi.sizeColumnsToFit();
      }
    },
    onChangePage: function(event){
      const payload ={
        pageSize:10,
        pageNumber:parseInt(event) -1
      }
      this.$processor.post('/account-data/get-all',payload).then((res) =>{
        let data = res.data.content;
        data.forEach(el =>{
          el.created = moment(el.createdTime).format('DD/MM/YYYY HH:ss');
        })
        this.rowData = data;
        this.totalPages = parseInt(res.data.totalPages,10);
      })
    },
    getListAccount: function(){
      const payload ={
        pageSize:10,
        pageNumber:0
      }
      this.$processor.post('/account-data/get-all',payload).then((res) =>{
        this.rowData = res.data.content;
        this.totalPages = parseInt(res.data.totalPages,10);
      })
    },
    addAccount: function(){
      this.$router.push('/admin/account-data').catch(()=>{})
    },
    initScreen: function(){
      this.currentPage = 1;
      this.getListAccount();
    },
    searchAccount: function(){
      const payload ={
        account: this.account
      }
      if(!this.account){
        this.getListAccount();
      }
      this.$processor.post('/account-data/find-by-name',payload).then((res) =>{
        this.rowData = res.data;
        this.currentPage = 1;
        this.totalPages = 1;
      })
    }
  },
  async created(){
    this.initScreen();
    this.$eventBus.$on('i18n',() => {
      this.columnDefs[0].headerName =  this.$t('adminUserICon.account');
      this.columnDefs[1].headerName =  this.$t('adminUserICon.pass');
      this.columnDefs[2].headerName =  this.$t('adminUserICon.creatorCode');
      this.columnDefs[3].headerName =  this.$t('adminUserICon.creator');
      this.columnDefs[4].headerName =  this.$t('adminUserICon.dateCreated');
      this.columnDefs[5].headerName =  this.$t('adminUserICon.accountStatus');
      this.columnDefs[6].headerName =  this.$t('adminUserICon.effect');
      this.columnDefs[7].headerName =  this.$t('adminUserICon.action');
      this.gridOptions.api.setColumnDefs(this.columnDefs);
    })
  },
  mounted() {
    this.gridApi = this.gridOptions.api;
  }

}
</script>
<style scoped>

</style>
